import {
    useState, useContext
} from 'react';
import {
    useParams
} from 'react-router-dom';
import {
    Context
} from 'shared/context/GlobalState';
import AlertModal from 'shared/components/Alertmodal';
import {
    Card, CardContent, CardFooter, CardTitle
} from 'shared/components/ui/card';
import {
    Label
} from 'shared/components/ui/label';
import {
    Button
} from 'shared/components/ui/button';
import {
    handleLeaveOrganization
} from 'shared/utils/organizationUtils';
import {
    OrganizationContext
} from 'shared/context/OrganizationContext';
import OrganizationCluster from 'features/organizations/settings/OrganizationCluster';
import SubOrganizationPlan from 'features/organizations/settings/Plan';
import SubscriptionDetails from 'features/organizations/settings/SubscriptionDetails';

export default function OrganizationSetting() {

    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const {
        oragID
    } = useParams();
    const {
        user, addNewNotifcation
    } = useContext(Context);
    const {
        selectedOrganization,
        getUserRole,
        subscription
    } = useContext(OrganizationContext);
    const roleInstance = getUserRole();

    const handleLeaveOrg = async () => {

        setDeleteLoading(true);
        try {
            await handleLeaveOrganization(oragID, user._id);
        } catch (error) {
            if (error.response?.status === 409) {
                addNewNotifcation('Super admin can not leave the organization', 'warning');
            } else {
                addNewNotifcation('Something went wrong. Please try again', 'warning');
            }
        } finally {
            setDeleteLoading(false);
        }

    };

    return (
        <div className='flex w-full overflow-y-scroll p-8'>
            <div className='mx-auto w-full max-w-4xl'>
                <div className='mb-8'>
                    <h1 className='text-2xl font-bold tracking-tight'>Settings</h1>
                    <p className='text-sm text-muted-foreground'>Manage {selectedOrganization.name} — cluster and subscription.</p>
                </div>
                <div className='h-auto space-y-6'>
                    <Card className="w-full p-6">
                        <CardTitle className='mb-6'> Organization </CardTitle>
                        <CardContent className='p-0'>
                            <dl className='grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2'>
                                <div className='flex flex-col gap-1'>
                                    <Label className='text-gray-500'>Name</Label>
                                    <span className='font-medium'>{selectedOrganization.name}</span>
                                </div>
                                <div className='flex flex-col gap-1'>
                                    <Label className='text-gray-500'>Created</Label>
                                    <span className='font-medium'>{new Date(selectedOrganization.created).toDateString()}</span>
                                </div>
                            </dl>
                        </CardContent>
                        {!roleInstance.isSuperAdmin && (
                            <CardFooter className='mt-6 flex justify-end p-0'>
                                <Button variant='destructive' onClick={() => setDeleteModal(true)}> Leave Organization </Button>
                                <AlertModal
                                    openModal={deleteModal}
                                    setopenModal={setDeleteModal}
                                    onDelete={handleLeaveOrg}
                                    loading={deleteLoading}
                                    title='Are you sure you want to leave this organization'
                                    subTitle=''
                                />
                            </CardFooter>
                        )}
                    </Card>

                    <OrganizationCluster />

                    {/* organization subscription */}
                    {subscription ? (
                        <SubscriptionDetails
                            isManage={getUserRole().isSuperAdmin}
                            subscription={subscription}
                        />
                    ) : (
                        <SubOrganizationPlan />
                    )}
                </div>
            </div>
        </div>
    );
}